import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "item", "prev", "next"]

  initialize() {
    this.currentIndex = 0
    this.totalItems = this.itemTargets.length
    this.isAnimating = false
  }

  connect() {
    this.updateCarousel()
    window.addEventListener("resize", () => this.handleResize())
  }

  disconnect() {
    window.removeEventListener("resize", () => this.handleResize())
  }

  handleResize() {
    this.currentIndex = 0
    this.updateCarousel()
  }

  next() {
    if (this.isAnimating) return
    const step = this.getItemsPerView()
    const maxIndex = this.totalItems - this.getItemsPerView()
    if (this.currentIndex + step <= maxIndex) {
      this.currentIndex += step
    } else {
      this.currentIndex = 0
    }
    this.updateCarousel()
  }

  prev() {
    if (this.isAnimating) return
    const step = this.getItemsPerView()
    const maxIndex = this.totalItems - this.getItemsPerView()
    if (this.currentIndex - step >= 0) {
      this.currentIndex -= step
    } else {
      this.currentIndex = maxIndex
    }
    this.updateCarousel()
  }

  getItemsPerView() {
    const width = window.innerWidth
    if (width < 768) return 1
    if (width < 1024) return 2
    return 5
  }

  updateCarousel() {
    if (this.itemTargets.length === 0) return

    this.isAnimating = true
    const itemWidth = this.itemTargets[0].offsetWidth
    const scrollAmount = this.currentIndex * (itemWidth + 16) // 16 = gap

    this.containerTarget.scrollTo({
      left: scrollAmount,
      behavior: "smooth"
    })

    setTimeout(() => {
      this.isAnimating = false
    }, 500)
  }
}
